import React from 'react'
import { Stack, Table, TableBody, Grid, TableCell, TableContainer, TableHead, TableRow, Box, Button, Paper, Tooltip } from '@mui/material'
import moment from 'moment/moment'
import { useSelector } from 'react-redux'
import { getWithHamaliAndCartageSummaryColumn } from '../common/reportConstants'

const DispatchMiddSection6 = ({
  tableData,
  loginData,
  reportType,
  showSummaryReport,
  detailedFilter,
  selFromBranch,
  selDestCity,
  selBranch,
  toDate,
  fromDate,
  selVehicle,
  selPaymentTpe,
}) => {
    const companySettings = useSelector((state) => state?.common?.companySettings)
    const loginCountryId = companySettings[0]?.DefaultCurrencyID;
    const UseToPayAsCOD=companySettings[0]?.UseToPayAsCOD
    const columns = getWithHamaliAndCartageSummaryColumn(loginCountryId,UseToPayAsCOD);
  const InsideRowContent = ({ item, index,fontVal,exl=0 }) => {
    return (
      <>
        <TableRow>
          {Object.keys(item).length == 15 ? (
            <>
              <TableCell
                className="reportTD"
                colSpan={4}
                style={{
                  color: '#000',
                  fontSize: fontVal,
                  fontWeight: '700',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  backgroundColor:'#EEE',
                  borderbottom: '1px solid rgba(0, 0, 0, 0.10)',
                }}
              >
                {item.Station}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  color: '#000',
                  fontSize: fontVal,
                  fontWeight: '700',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  backgroundColor:'#EEE'
                }}
              >
                {item.TotalUnits.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  color: '#000',
                  fontSize: fontVal,
                  fontWeight: '700',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  backgroundColor:'#EEE'
                }}
              >
                {item.TotalLRCount.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  color: '#000',
                  fontSize: fontVal,
                  fontWeight: '700',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  backgroundColor:'#EEE'
                }}
              >
                {item.TotalFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  color: '#000',
                  fontSize: fontVal,
                  fontWeight: '700',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  backgroundColor:'#EEE'
                }}
              >
                {item.TopayFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  color: '#000',
                  fontSize: fontVal,
                  fontWeight: '700',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  backgroundColor:'#EEE'
                }}
              >
                {item.PaidFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  color: '#000',
                  fontSize: fontVal,
                  fontWeight: '700',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  backgroundColor:'#EEE'
                }}
              >
                {item.OnAccountFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  color: '#000',
                  fontSize: fontVal,
                  fontWeight: '700',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  backgroundColor:'#EEE'
                }}
              >
                {item.FocAndSelfFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  color: '#000',
                  fontSize: fontVal,
                  fontWeight: '700',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  backgroundColor:'#EEE'
                }}
              >
                {item.DDDVFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  color: '#000',
                  fontSize: fontVal,
                  fontWeight: '700',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  backgroundColor:'#EEE'
                }}
              >
                {item.HamaliTotal.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={(exl===1&&loginCountryId===2) ? 2 : 1}
                style={{
                  color: '#000',
                  fontSize: fontVal,
                  fontWeight: '700',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  backgroundColor:'#EEE'
                }}
              >
                {item.CartageTotal.toFixed(2)}
              </TableCell>
              {loginCountryId!==2 &&<TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  color: '#000',
                  fontSize: fontVal,
                  fontWeight: '700',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  backgroundColor:'#EEE'
                }}
              >
                {item.GstTotal.toFixed(2)}
              </TableCell>}
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  color: '#000',
                  fontSize: fontVal,
                  fontWeight: '700',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  backgroundColor:'#EEE'
                }}
              >
                {item.ValuationTotal.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  color: '#000',
                  fontSize: fontVal,
                  fontWeight: '700',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  backgroundColor:'#EEE'
                }}
              >
                {item.OtherChargeTotal.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  color: '#000',
                  fontSize: fontVal,
                  fontWeight: '700',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  backgroundColor:'#EEE'
                }}
              >
                {item.TotalNetAmount.toFixed(2)}
              </TableCell>
            </>
          ) : (
            <>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ fontWeight: 'bold', background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'left' }}
              >
                {item.SN}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ fontWeight: 'bold', background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'left' }}
              >
                {item.BusNumber}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ fontWeight: 'bold', background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'left',whiteSpace: 'pre',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '150px', }}
              >
                <Tooltip title={`${item.DriverConductorContactNo}`} placement="top-start">
                  <span>
                    {item.DriverConductorContactNo} <br />
                  </span>
                </Tooltip>
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ fontWeight: 'bold', background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'left' }}
              >
                {item.Station}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ fontWeight: 'bold', background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'right' }}
              >
                {item.TotalUnits}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ fontWeight: 'bold', background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'right' }}
              >
                {item.TotalLRCount}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ fontWeight: 'bold', background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'right' }}
              >
                {item.TotalFreight}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ fontWeight: 'bold', background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'right' }}
              >
                {item.TopayFreight}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ fontWeight: 'bold', background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'right' }}
              >
                {item.PaidFreight}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ fontWeight: 'bold', background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'right' }}
              >
                {item.OnAccountFreight}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ fontWeight: 'bold', background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'right' }}
              >
                {item.FocAndSelfFreight}
              </TableCell>

              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ fontWeight: 'bold', background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'right' }}
              >
                {item.DDDVFreight}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ fontWeight: 'bold', background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'right' }}
              >
                {item.HamaliTotal}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={(exl===1&&loginCountryId===2) ? 2 : 1}
                style={{ fontWeight: 'bold', background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'right' }}
              >
                {item.CartageTotal}
              </TableCell>
              {loginCountryId!==2&&<TableCell
                className="reportTD"
                colSpan={1}
                style={{ fontWeight: 'bold', background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'right' }}
              >
                {item.GstTotal}
              </TableCell>}
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ fontWeight: 'bold', background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'right' }}
              >
                {item.ValuationTotal}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ fontWeight: 'bold', background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'right' }}
              >
                {item.OtherChargeTotal}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ fontWeight: 'bold', background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'right' }}
              >
                {item.TotalNetAmount}
              </TableCell>
            </>
          )}
        </TableRow>
      </>
    )
  }
  return (
    <>
      <Stack sx={{ marginLeft: 2, marginRight: 2, height: 480, paddingTop: '10px' }}>
        <TableContainer className="scrollBlue" sx={{"&::-webkit-scrollbar": {width:'6px',height:'6px'},border:'1px solid #aeaeae','& .MuiTableCell-root': {
            fontSize: '14px !important'
        }}} component={Paper}>
          <Table className="table1 table-Report " size="small" aria-label="a dense table">
            <TableHead style={{ fontWeight: 'bold', position: 'sticky', top: '0' }}>
              <TableRow >
                <TableCell
                  className="reportTD"
                  style={{
                    fontWeight: 'bold',
                    fontSize: '14px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '700',
                    textAlign: 'left',
                    color: '#444444',
                    height:'36px',
                    backgroundColor: '#bfe1ff'
                  }}
                  colSpan={6}
                >
                  Dispatch By Branch: {selFromBranch?.name || loginData?.strBranchName}
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{
                    fontWeight: 'bold',
                    fontSize: '14px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '700',
                    textAlign: 'center',
                    color: '#444444',
                    height:'36px',
                    backgroundColor: '#bfe1ff'
                  }}
                  colSpan={6}
                >
                  Destination City:{selDestCity?.name}
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{
                    fontWeight: 'bold',
                    fontSize: '14px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '700',
                    textAlign: 'right',
                    color: '#444444',
                    height:'36px',
                    backgroundColor: '#bfe1ff'
                  }}
                  colSpan={6}
                >
                  Destination Branch: {selBranch?.name}
                </TableCell>
              </TableRow>
              <TableRow style={{ color: 'white' }}>
                {columns.map((col, index) => (
                  <TableCell
                    key={index}
                    className="ReportItemHead"
                    style={{
                      fontWeight: 'bold',
                      fontSize: '14px',
                      lineheight: '16px',
                      letterspacing: '0.24px',
                      fontWeight: '700',
                      color: '#444444',
                      height: '36px',
                      backgroundColor: '#bfe1ff',
                      textAlign: index === 0 || index === 1 || index === 2 || index === 3 ? 'left' : 'right',
                      whiteSpace: 'pre',
                      verticalAlign: 'top',
                    }}
                    colSpan={1}
                  >
                    {col.headerName}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {tableData?.length < 1 ? (
              <>
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={18}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          marginTop: '20px',
                          marginBottom: '20px',
                          color: 'red',
                          fontSize: '12px',
                        }}
                      >
                        <span>No results found. Please refine your search parameters and search again.</span>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </>
            ) : tableData?.length > 1 ? (
              <TableBody
                className="filter-data-row"
                style={{ textAlign: 'center', fontSize: '14px', fontWeight: '500', marginLeft: '5px' }}
              >
                {tableData?.map((item, index) => (
                  <InsideRowContent item={item} index={index} key={index} fontVal={"12px"}/>
                ))}
              </TableBody>
            ) : (
              ''
            )}
          </Table>
          <Table style={{display:'none'}} id="tables" className="table1 table-Report " size="small" aria-label="a dense table">
            <TableHead style={{ display: 'none', fontWeight: 'bold' }}>
              <TableRow>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '24px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={9}
                >
                  <h3 style={{ paddingLeft: '17px' }}>Report For: Dispatch Report -</h3>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '24px', fontWeight: '500', textAlign: 'right' }}
                  colSpan={9}
                >
                  <h3 style={{ paddingLeft: '17px' }}>Company Name : {loginData.strCompanyName}</h3>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={18}></TableCell>
              </TableRow>
              <TableRow style={{ color: 'white' }}>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={2}
                >
                  From Dispatch Date
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={2}
                >
                  To Dispatch Date
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={2}
                >
                  dispatch By Branch
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={2}
                >
                  Destination City
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={2}
                >
                  DestinationBranch
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={1}
                >
                  Vehicle Number
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={1}
                >
                  Payment Type
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={2}
                >
                  Report Type
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={2}
                >
                  Report View
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={2}
                >
                  Report Option
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={2}
                >
                  <span>{moment(fromDate).format('MM/DD/YYYY')}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={2}
                >
                  <span>{moment(toDate).format('MM/DD/YYYY')}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={2}
                >
                  <span>{selFromBranch?.name || loginData?.strBranchName}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={2}
                >
                  <span>{selDestCity?.name}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={2}
                >
                  <span>{selBranch?.name}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={1}
                >
                  <span>{selVehicle?.name}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={1}
                >
                  <span>{selPaymentTpe?.name || 'All'}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={2}
                >
                  <span>{reportType?.Name}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={2}
                >
                  <span>{showSummaryReport?.Name}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={2}
                >
                  <span>{detailedFilter?.Name} </span>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={18}></TableCell>
              </TableRow>
            </TableHead>
            <TableHead style={{ fontWeight: 'bold', position: 'sticky', top: '0' }}>
              <TableRow >
                <TableCell
                  className="reportTD"
                  style={{
                    fontWeight: 'bold',
                    fontSize: '20px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '700',
                    textAlign: 'left',
                    color: '#444444',
                    height:'36px',
                    backgroundColor: '#bfe1ff'
                  }}
                  colSpan={6}
                >
                  Dispatch By Branch: {selFromBranch?.name || loginData?.strBranchName}
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{
                    fontWeight: 'bold',
                    fontSize: '20px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '700',
                    textAlign: 'center',
                    color: '#444444',
                    height:'36px',
                    backgroundColor: '#bfe1ff'
                  }}
                  colSpan={6}
                >
                  Destination City:{selDestCity?.name}
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{
                    fontWeight: 'bold',
                    fontSize: '20px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '700',
                    textAlign: 'right',
                    color: '#444444',
                    height:'36px',
                    backgroundColor: '#bfe1ff'
                  }}
                  colSpan={6}
                >
                  Destination Branch: {selBranch?.name}
                </TableCell>
              </TableRow>
              <TableRow style={{ color: 'white' }}>
                {columns.map((col, index) => (
                  <TableCell
                    key={index}
                    className="ReportItemHead"
                    style={{
                      fontWeight: 'bold',
                      fontSize: '20px',
                      lineheight: '16px',
                      letterspacing: '0.24px',
                      fontWeight: '700',
                      color: '#444444',
                      height: '36px',
                      backgroundColor: '#bfe1ff',
                      textAlign: index === 1 || index === 2 || index === 3 || index === 4 ? 'left' : 'right',
                      whiteSpace: 'pre',
                      verticalAlign: 'top',
                    }}
                    colSpan={1}
                  >
                    {col.headerName}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {tableData?.length < 1 ? (
              <>
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={18}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          marginTop: '20px',
                          marginBottom: '20px',
                          color: 'red',
                          fontSize: '20px',
                        }}
                      >
                        <span>No results found. Please refine your search parameters and search again.</span>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </>
            ) : tableData?.length > 1 ? (
              <TableBody
                className="filter-data-row"
                style={{ textAlign: 'center', fontSize: '14px', fontWeight: '500', marginLeft: '5px' }}
              >
                {tableData?.map((item, index) => (
                  <InsideRowContent item={item} index={index} key={index} exl={1} fontVal={'20px'}/>
                ))}
              </TableBody>
            ) : (
              ''
            )}
          </Table>
        </TableContainer>
      </Stack>
    </>
  )
}

export default DispatchMiddSection6
